import React from "react";
import { Col, Row } from "react-bootstrap";

import classNames from "classnames";
import DOMPurify from "dompurify";

import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import { TOURNAMENT_LOGO_URL } from "../../../../../../lib/globals";
import { IMasterTournament } from "../../../../../../types/api";
import { useTournamentContext } from "../../contexts/Tournament";
import { dateFormat } from "../../lib/dateFormat";

const MasterTouranment = (): React.JSX.Element => {
    const { tournament: masterTournament } = useTournamentContext();
    const tournament = masterTournament as IMasterTournament;
    const tournaments = useAppSelector(
        state => state.tournamentmanagement.tournaments,
    );
    console.log(tournaments);

    return (
        <>
            <Row className={classNames("mt-0")}>
                <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="align-content-center text-center"
                >
                    {tournament.logo && (
                        <img
                            src={`${TOURNAMENT_LOGO_URL}${tournament.logo}`}
                            alt={tournament.name}
                            className="logo"
                        />
                    )}
                </Col>
                <Col
                    xs={12}
                    md={6}
                    lg={8}
                    className="align-content-center px-5"
                >
                    <div className="tournamentInfo pl-2">
                        <h4>
                            {dateFormat.format(new Date(tournament.startDate))}{" "}
                            - {dateFormat.format(new Date(tournament.endDate))}
                        </h4>
                        <h4>
                            {tournaments
                                .filter(t => t.parent === tournament.id)
                                .map(t => (
                                    <span className="ageLevel" key={t.id}>
                                        {t.maxTeams &&
                                        (t.teams
                                            ? t.teams.length >=
                                              parseInt(t.maxTeams?.toString())
                                            : false) ? (
                                            <s>{t.ageLevel}</s>
                                        ) : (
                                            t.ageLevel
                                        )}
                                    </span>
                                ))}
                        </h4>
                        <h4>Competition Level: {tournament.designation}</h4>
                        <h4>{tournament.field.name}</h4>
                    </div>
                </Col>
            </Row>
            {tournament.description && (
                <Row className="tournamentDescription">
                    <Col
                        className="px-0"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(tournament.description),
                        }}
                    />
                </Row>
            )}
        </>
    );
};

export default MasterTouranment;
